(function(){
  var els = document.querySelectorAll('.ml-reveal, .ml-reveal-left, .ml-reveal-right');
  if (!els.length) return;
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if (e.isIntersecting) {
        e.target.classList.add('ml-visible');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.12 });
  els.forEach(function(el){ io.observe(el); });
})();

/* Barre de menu mobile : reprend exactement les rubriques du menu ordinateur */
(function(){
  var nav = document.querySelector('.ml-mobile-nav');
  var items = document.querySelectorAll('.header__inline-menu > ul > li');
  if (!nav || !items.length) return;
  var links = [];
  items.forEach(function(li){
    var label = '', href = '';
    var summary = li.querySelector('summary');
    if (summary) {
      label = summary.textContent;
      var first = li.querySelector('details a[href]');
      if (first) href = first.getAttribute('href');
    } else {
      var a = li.querySelector('a[href]');
      if (a) { label = a.textContent; href = a.getAttribute('href'); }
    }
    label = (label || '').replace(/\s+/g, ' ').trim();
    if (label && href) links.push({ label: label, href: href });
  });
  if (!links.length) return;
  nav.innerHTML = '';
  var path = window.location.pathname;
  links.forEach(function(l){
    var a = document.createElement('a');
    a.href = l.href;
    a.textContent = l.label;
    var p = '';
    try { p = new URL(l.href, window.location.origin).pathname; } catch (e) {}
    if (p && p !== '/' && path.indexOf(p) === 0) a.classList.add('active');
    nav.appendChild(a);
  });
})();
